import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation} from "swiper/modules";
import {newsData} from "../../assets/data/news.data";
import {useTranslation} from "react-i18next";

export default function SwiperNewsComponent(props) {
    const {i18n} = useTranslation();
    const lang = i18n.language;

    return (
        <Swiper
            className={props.isMobile ? "min-h-fit" : "min-h-[400px]"}
            slidesPerView={1}
            spaceBetween={0}
            loop={true}
            autoplay={{
                delay: 7000,
                disableOnInteraction: false
            }}
            navigation={true}
            modules={[Navigation, Autoplay]}
        >
            {newsData.map((news, i) => {
                return (
                    <SwiperSlide
                        key={i}
                    >
                        <div
                            className={`w-full flex ${props.isMobile ? 'flex-col gap-4' : 'gap-8'} items-center justify-center py-9 px-12`}
                        >
                            <div
                                className={`${props.isMobile ? 'w-full min-h-[300px]' : 'w-1/2 min-h-[400px]'} rounded-lg`}
                                style={{
                                    backgroundImage: `url(${news.img})`,
                                    backgroundPosition: "center center",
                                    backgroundSize: "cover",
                                }}/>

                            <div
                                className={`${props.isMobile ? 'w-full min-h-fit' : 'w-1/2 min-h-[400px]'} flex flex-col gap-1`}>
                                <h3>{news[`title_${lang}`]}</h3>
                                <p dangerouslySetInnerHTML={{__html: news[`description_${lang}`]}}/>
                            </div>
                        </div>
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
}